module.exports = __webpack_public_path__ + "img/2-4.9e9a4224.svg";